// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_96-0";
export var orangeButton = "_96-1";